import { Component, OnInit } from '@angular/core'
import { OffersService } from '../../services/offers.service'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { OfferModelData } from '../../models/offer.model'
import { Subscription } from 'rxjs'

@Component({
	selector: 'app-view-promo-code',
	templateUrl: './view-promo-code.component.html',
	styleUrls: ['./view-promo-code.component.scss'],
})
export class ViewPromoCodeComponent implements OnInit {
	subscription = new Subscription()
	offerData!: OfferModelData
	breadCrumbRout: any
	constructor(
		private offersService: OffersService,
		private activeRout: ActivatedRoute,
		public translate: TranslateService,
		private SharedService: SharedService
	) {
		this.SharedService.handleBreadCrumb('view-promo-code', false, {
			name: '',
			id: null,
			url: '',
			queryParams:null,
		})
	}

	ngOnInit(): void {
		const id = this.activeRout.snapshot.params['id']
		this.getService(id)
	}

	getService(id: number) {
		this.subscription.add(
			this.offersService.getOffer(id).subscribe((res: any) => {
				this.offerData = res.result
				this.updateHeaderTitle()
			})
		)
	}

	updateHeaderTitle() {
		const promoCodeName = this.offerData.name
		const headerTitle =
			this.translate.currentLang === 'ar'
				? promoCodeName?.ar
				: promoCodeName?.en
		this.SharedService.headerTitle.next(headerTitle)
	}
	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
